import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IUser } from 'apps/resource-portal/src/app/models/user';

@Component({
  selector: 'concourse-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  photo: any = ['/assets/images/user-icon.png'];
  profileForm: UntypedFormGroup;
  @Input() data: IUser;
  @ViewChild('file', { static: false }) file: ElementRef<HTMLElement>;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.profileForm = new UntypedFormGroup({
      email: new UntypedFormControl(this.data.email || '', [Validators.email, Validators.email]),
      firstname: new UntypedFormControl(this.data.firstname || '', [Validators.required]),
      lastname: new UntypedFormControl(this.data.lastname || '', [Validators.required]),
      mobilephone: new UntypedFormControl(this.data.mobilephone, [Validators.required]),
    });
  }

  triggerClick(): void {
    const el: HTMLElement = this.file.nativeElement;
    el.click();
  }

  onSelectFile(event) {
    if (event.target.files.length === 1) {
      if (event.target.files && event.target.files[0]) {
        console.log(event.target.files);
        const reader = new FileReader();

        reader.readAsDataURL(event.target.files[0]); // read file as data url

        reader.onload = (event) => { // called once readAsDataURL is completed
          this.photo = [event.target['result']];
          console.log(this.photo);
          
        };
        // const reader = new FileReader();
        // reader.readAsDataURL(event.target.files[0]); // read file as data url
        // reader.onload = (event) => { // called once readAsDataURL is completed
        //   this.photo = [event.target['result']];
        // };
      }
    }
  }

  saveProfile() {

  }

}
